"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ramda_1 = require("ramda");

var utils_1 = require("@8base/utils");

var getFieldSchemaFeatures = function getFieldSchemaFeatures(_ref, tablesList) {
  var tableName = _ref.tableName,
      appName = _ref.appName,
      fieldName = _ref.fieldName,
      tableId = _ref.tableId,
      fieldId = _ref.fieldId;

  if (!!tableId && !!fieldId) {
    var table = utils_1.tablesListSelectors.getTableById(tablesList, tableId);
    var field = utils_1.tableSelectors.getFieldById(table, fieldId);
    return utils_1.tableFieldSelectors.getSchemaFeatures(field);
  } else if (!!tableName && !!fieldName) {
    var _table = utils_1.tablesListSelectors.getTableByName(tablesList, tableName, appName);

    var _field = utils_1.tableSelectors.getFieldByName(_table, fieldName);

    return utils_1.tableFieldSelectors.getSchemaFeatures(_field);
  }

  return {};
};

var getFieldDataFeatures = function getFieldDataFeatures(_ref2, tablesList) {
  var tableName = _ref2.tableName,
      appName = _ref2.appName,
      fieldName = _ref2.fieldName,
      tableId = _ref2.tableId,
      fieldId = _ref2.fieldId;

  if (!!tableId && !!fieldId) {
    var table = utils_1.tablesListSelectors.getTableById(tablesList, tableId);
    var field = utils_1.tableSelectors.getFieldById(table, fieldId);
    return utils_1.tableFieldSelectors.getDataFeatures(field);
  } else if (!!tableName && !!fieldName) {
    var _table2 = utils_1.tablesListSelectors.getTableByName(tablesList, tableName, appName);

    var _field2 = utils_1.tableSelectors.getFieldByName(_table2, fieldName);

    return utils_1.tableFieldSelectors.getDataFeatures(_field2);
  }

  return {};
};

var getTableSchemaFeatures = function getTableSchemaFeatures(_ref3, tablesList) {
  var tableName = _ref3.tableName,
      appName = _ref3.appName,
      tableId = _ref3.tableId;

  if (!!tableId) {
    var table = utils_1.tablesListSelectors.getTableById(tablesList, tableId);
    return utils_1.tableSelectors.getSchemaFeatures(table);
  } else if (!!tableName) {
    var _table3 = utils_1.tablesListSelectors.getTableByName(tablesList, tableName, appName);

    return utils_1.tableSelectors.getSchemaFeatures(_table3);
  }

  return {};
};

var getTableDataFeatures = function getTableDataFeatures(_ref4, tablesList) {
  var tableName = _ref4.tableName,
      appName = _ref4.appName,
      tableId = _ref4.tableId;

  if (!!tableId) {
    var table = utils_1.tablesListSelectors.getTableById(tablesList, tableId);
    return utils_1.tableSelectors.getDataFeatures(table);
  } else if (!!tableName) {
    var _table4 = utils_1.tablesListSelectors.getTableByName(tablesList, tableName, appName);

    return utils_1.tableSelectors.getDataFeatures(_table4);
  }

  return {};
};

var Features = {
  schema: {
    isUpdateTableAllowed: function isUpdateTableAllowed(_ref5, tablesList) {
      var tableName = _ref5.tableName,
          appName = _ref5.appName,
          tableId = _ref5.tableId,
          fieldName = _ref5.fieldName;
      var schemaFeatures = getTableSchemaFeatures({
        tableName: tableName,
        appName: appName,
        tableId: tableId
      }, tablesList);
      return ramda_1.pathOr(false, ['update', fieldName], schemaFeatures);
    },
    isCreateFieldByTypeAllowed: function isCreateFieldByTypeAllowed(_ref6, tablesList) {
      var tableName = _ref6.tableName,
          appName = _ref6.appName,
          tableId = _ref6.tableId,
          fieldType = _ref6.fieldType;
      var schemaFeatures = getTableSchemaFeatures({
        tableName: tableName,
        appName: appName,
        tableId: tableId
      }, tablesList);
      return ramda_1.pathOr(false, ['create', fieldType], schemaFeatures);
    },
    isCreateFieldAllowed: function isCreateFieldAllowed(_ref7, tablesList) {
      var tableName = _ref7.tableName,
          appName = _ref7.appName,
          tableId = _ref7.tableId;
      return Object.keys(utils_1.FIELD_TYPE).reduce(function (result, fieldType) {
        return result || Features.schema.isCreateFieldByTypeAllowed({
          tableName: tableName,
          appName: appName,
          tableId: tableId,
          fieldType: fieldType
        }, tablesList);
      }, false);
    },
    isUpdateFieldAllowed: function isUpdateFieldAllowed(options, tablesList) {
      var schemaFeatures = getFieldSchemaFeatures(options, tablesList);
      return ramda_1.propOr(false, 'update', schemaFeatures);
    },
    isDeleteFieldAllowed: function isDeleteFieldAllowed(options, tablesList) {
      var schemaFeatures = getFieldSchemaFeatures(options, tablesList);
      return ramda_1.propOr(false, 'delete', schemaFeatures);
    }
  },
  data: {
    isCreateRecordAllowed: function isCreateRecordAllowed(options, tablesList) {
      var dataFeatures = getTableDataFeatures(options, tablesList);
      return ramda_1.propOr(false, 'create', dataFeatures);
    },
    isUpdateRecordAllowed: function isUpdateRecordAllowed(options, tablesList) {
      var dataFeatures = getTableDataFeatures(options, tablesList);
      return ramda_1.propOr(false, 'update', dataFeatures);
    },
    isDeleteRecordAllowed: function isDeleteRecordAllowed(options, tablesList) {
      var dataFeatures = getTableDataFeatures(options, tablesList);
      return ramda_1.propOr(false, 'delete', dataFeatures);
    },
    isCreateFieldAllowed: function isCreateFieldAllowed(options, tablesList) {
      var dataFeatures = getFieldDataFeatures(options, tablesList);
      return ramda_1.propOr(false, 'create', dataFeatures);
    },
    isUpdateFieldAllowed: function isUpdateFieldAllowed(options, tablesList) {
      var dataFeatures = getFieldDataFeatures(options, tablesList);
      return ramda_1.propOr(false, 'update', dataFeatures);
    }
  }
};
exports.Features = Features;